import { render } from "./FieldSelectButtonsFullSize.vue?vue&type=template&id=fc7d5cc0"
import script from "./FieldSelectButtonsFullSize.vue?vue&type=script&lang=js"
export * from "./FieldSelectButtonsFullSize.vue?vue&type=script&lang=js"

import exportComponent from "/home/alexey/mv/mortgageware/vendor/sudoux/cms/Sudoux/Cms/FormBundle/Resources/views/Vuejs/Apps/formbuilder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QField from 'quasar/src/components/field/QField.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QField,QBtn});
